import { ReadCallback } from 'i18next';
import HttpBackend, { HttpBackendOptions } from 'i18next-http-backend';

interface CustomBackendOptions extends HttpBackendOptions {
  customLoadPaths: string[];
}

class CustomBackend extends HttpBackend {
  constructor(services: unknown, options: CustomBackendOptions) {
    super(services, options);
  }

  read(language: string, namespace: string, callback: ReadCallback): void {
    const customPaths =
      (this.options as CustomBackendOptions).customLoadPaths || [];
    const defaultPaths = [
      `locales/${language}/${namespace}.json`,
      `locales/${language}/subModules/${namespace}.json`,
    ];
    const loadPaths: string[] = [...customPaths, ...defaultPaths];

    const loadFile = (path: string[], index: number): void => {
      if (index >= path.length) {
        callback(
          new Error(
            `Unable to load translations for ${namespace} in ${language}`
          ),
          false
        );
        return;
      }

      this.loadUrl(
        this.services.interpolator.interpolate(path[index], {
          lng: language,
          ns: namespace,
        }),
        (err, data) => {
          if (err && index < path.length - 1) {
            loadFile(path, index + 1);
          } else {
            callback(err, data);
          }
        }
      );
    };

    loadFile(loadPaths, 0);
  }
}

export default CustomBackend;
